"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelSchedulerCallback = exports.requestSchedulerCallback = exports.cancelIdleCallback = exports.requestIdleCallback = void 0;

var _react = _interopRequireDefault(require("react"));

/* eslint-disable compat/compat */
var requestIdleCallback = window.requestIdleCallback || setTimeout;
exports.requestIdleCallback = requestIdleCallback;
var cancelIdleCallback = window.cancelIdleCallback || clearTimeout;
exports.cancelIdleCallback = cancelIdleCallback;
var Scheduler = _react.default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && _react.default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Scheduler; // TODO fix when scheduler api stable

var requestSchedulerCallback = Scheduler ? function (callback) {
  // forward compat: we need to check arity because argument order changed in 16.9.0
  return Scheduler.unstable_scheduleCallback.length === 2 ? Scheduler.unstable_scheduleCallback(callback) : Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, callback);
} : requestIdleCallback;
exports.requestSchedulerCallback = requestSchedulerCallback;
var cancelSchedulerCallback = Scheduler ? function (id) {
  if (id) {
    Scheduler.unstable_cancelCallback(id);
  }
} : cancelIdleCallback;
exports.cancelSchedulerCallback = cancelSchedulerCallback;